import type { IconProps } from "../Icon.props";
import createWebIcon from "../createWebIcon";
import validateKeys from "../validateKeys";

// =============================================================================
// Flex Align Items Icons - Vertical position visual representations
// =============================================================================

export function AlignStart(props: IconProps): JSX.Element {
  const Icon = createWebIcon({
    ...props,
    name: "AlignStart",
    viewBox: "0 0 16 16",
    path: (
      <>
        <line
          x1="2"
          y1="2.5"
          x2="14"
          y2="2.5"
          stroke="currentColor"
          strokeWidth="1"
          opacity="0.4"
          className="icon-outline"
        />
        <rect
          x="3"
          y="3.5"
          width="3"
          height="8"
          rx="0.5"
          fill="currentColor"
          className="icon-primary"
        />
        <rect
          x="7"
          y="3.5"
          width="3"
          height="5"
          rx="0.5"
          fill="currentColor"
          className="icon-primary"
        />
        <rect
          x="11"
          y="3.5"
          width="2"
          height="6"
          rx="0.5"
          fill="currentColor"
          className="icon-primary"
        />
      </>
    ),
  });
  return <Icon {...validateKeys(props)} />;
}

export function AlignCenter(props: IconProps): JSX.Element {
  const Icon = createWebIcon({
    ...props,
    name: "AlignCenter",
    viewBox: "0 0 16 16",
    path: (
      <>
        <line
          x1="2"
          y1="8"
          x2="14"
          y2="8"
          stroke="currentColor"
          strokeWidth="1"
          opacity="0.4"
          className="icon-outline"
        />
        <rect
          x="3"
          y="4"
          width="3"
          height="8"
          rx="0.5"
          fill="currentColor"
          className="icon-primary"
        />
        <rect
          x="7"
          y="5.5"
          width="3"
          height="5"
          rx="0.5"
          fill="currentColor"
          className="icon-primary"
        />
        <rect
          x="11"
          y="5"
          width="2"
          height="6"
          rx="0.5"
          fill="currentColor"
          className="icon-primary"
        />
      </>
    ),
  });
  return <Icon {...validateKeys(props)} />;
}

export function AlignEnd(props: IconProps): JSX.Element {
  const Icon = createWebIcon({
    ...props,
    name: "AlignEnd",
    viewBox: "0 0 16 16",
    path: (
      <>
        <line
          x1="2"
          y1="13.5"
          x2="14"
          y2="13.5"
          stroke="currentColor"
          strokeWidth="1"
          opacity="0.4"
          className="icon-outline"
        />
        <rect
          x="3"
          y="4.5"
          width="3"
          height="8"
          rx="0.5"
          fill="currentColor"
          className="icon-primary"
        />
        <rect
          x="7"
          y="7.5"
          width="3"
          height="5"
          rx="0.5"
          fill="currentColor"
          className="icon-primary"
        />
        <rect
          x="11"
          y="6.5"
          width="2"
          height="6"
          rx="0.5"
          fill="currentColor"
          className="icon-primary"
        />
      </>
    ),
  });
  return <Icon {...validateKeys(props)} />;
}

export function AlignStretch(props: IconProps): JSX.Element {
  const Icon = createWebIcon({
    ...props,
    name: "AlignStretch",
    viewBox: "0 0 16 16",
    path: (
      <>
        <line
          x1="2"
          y1="2.5"
          x2="14"
          y2="2.5"
          stroke="currentColor"
          strokeWidth="1"
          opacity="0.4"
          className="icon-outline"
        />
        <line
          x1="2"
          y1="13.5"
          x2="14"
          y2="13.5"
          stroke="currentColor"
          strokeWidth="1"
          opacity="0.4"
          className="icon-outline"
        />
        <rect
          x="3"
          y="3.5"
          width="3"
          height="9"
          rx="0.5"
          fill="currentColor"
          className="icon-primary"
        />
        <rect
          x="7"
          y="3.5"
          width="3"
          height="9"
          rx="0.5"
          fill="currentColor"
          className="icon-primary"
        />
        <rect
          x="11"
          y="3.5"
          width="2"
          height="9"
          rx="0.5"
          fill="currentColor"
          className="icon-primary"
        />
      </>
    ),
  });
  return <Icon {...validateKeys(props)} />;
}
